<template>
  <!--
    Per-supplier search progress row for the streaming (v2) search UX.
    Renders only while a streaming search is in flight OR still has chips populated.
    Each chip: 'loading' → spinner + name · 'done' → ✓ + name + count · 'error' → ✗ + name.
    Data comes from state.supplierStatus / state.supplierCounts, written by
    FETCH_STREAM_SEARCH in store/index.js.
  -->
  <div class="supplier-chips" v-if="hasChips">
    <span
      v-for="(status, supplier) in supplierStatus"
      :key="supplier"
      class="supplier-chip"
      :class="['is-' + status]"
    >
      <span v-if="status === 'loading'" class="supplier-chip__spinner" aria-hidden="true"></span>
      <span v-else-if="status === 'error'" class="supplier-chip__icon" aria-hidden="true">✗</span>
      <span v-else class="supplier-chip__icon" aria-hidden="true">✓</span>
      <strong class="supplier-chip__name">{{ supplier }}</strong>
      <span class="supplier-chip__count" v-if="status === 'done'">{{ supplierCounts[supplier] }}</span>
      <span class="supplier-chip__count" v-else-if="status === 'loading'">…</span>
    </span>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'SupplierProgressChips',
  computed: {
    ...mapGetters({
      supplierStatus: 'GET_SUPPLIER_STATUS',
      supplierCounts: 'GET_SUPPLIER_COUNTS',
    }),
    hasChips() {
      return this.supplierStatus && Object.keys(this.supplierStatus).length > 0;
    },
  },
};
</script>

<style scoped>
.supplier-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  padding: 12px 0;
  margin-bottom: 12px;
}
.supplier-chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 14px;
  border-radius: 999px;
  border: 1px solid #dbe0e6;
  background: #f7f9fb;
  font-size: 13px;
  color: #1a3a5c;
  transition: background 0.2s, border-color 0.2s;
}
.supplier-chip.is-loading {
  background: #eef4fb;
  border-color: #c4d8ee;
}
.supplier-chip.is-done {
  background: #eaf7ee;
  border-color: #b8dfc5;
  color: #1e6b3a;
}
.supplier-chip.is-error {
  background: #fdecec;
  border-color: #f0b8b8;
  color: #a3271f;
}
.supplier-chip__name {
  font-weight: 700;
  letter-spacing: 0.02em;
}
.supplier-chip__count {
  font-variant-numeric: tabular-nums;
  min-width: 1.6em;
  text-align: center;
}
.supplier-chip__icon {
  font-weight: 700;
  font-size: 14px;
  line-height: 1;
}
.supplier-chip__spinner {
  width: 12px;
  height: 12px;
  border: 2px solid rgba(26, 58, 92, 0.2);
  border-top-color: #1a3a5c;
  border-radius: 50%;
  animation: supplier-chip-spin 0.7s linear infinite;
}
@keyframes supplier-chip-spin {
  to { transform: rotate(360deg); }
}
</style>
